import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const toggleLanguage = () => {
        const newLang = i18n.language === 'ar' ? 'en' : 'ar';
        i18n.changeLanguage(newLang);

        // Update HTML attributes
        document.documentElement.lang = newLang;
        document.documentElement.dir = newLang === 'ar' ? 'rtl' : 'ltr';
    };

    return (
        <button
            className="language-switcher"
            onClick={toggleLanguage}
            aria-label="Switch Language"
        >
            {i18n.language === 'ar' ? 'English' : 'العربية'}
        </button>
    );
};

export default LanguageSwitcher;
